module.exports = __webpack_public_path__ + "img/space-stock-h.4aaf4779.png";